import { createAsyncAction } from "typesafe-actions";
export const fetchSpeakers = createAsyncAction("[engine] fetch speakers request", "[engine] fetch speakers success", "[engine] fetch speakers failure", "[engine] fetch speakers cancel")();
